<ng-container *ngIf="dialog$ | async as dialog">
    <div class="paybee-modal-header">
      <div class="modal-title">{{ modalTitle }}</div>
      <div class="modal-subtitle mt-2" [innerHTML]=modalSubtitle></div>
    </div>
    <div class="modal-body">
        <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput [formControl]="newName" maxLength="128" [label]='inputLabel'></app-mdbp-input>
            <mdb-error class="form-fill-error"  *ngIf="newName.invalid && newName.touched ">Please provide Event Name</mdb-error>
          </mdb-form-control>
          <div class="row justify-content-left">
            <div class="col">
                <app-datetime
                    dateLabel="Event Date"
                    timeLabel="Event Time"
                    [formControl]="startDateTimeGmtUnix"
                    [submitted] = submitted
                    required="true"
                    data-panel="eventSettings"
                ></app-datetime>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <mdb-form-control class="form-fill" data-panel="eventSettings">
                    <app-mdbp-input mdbInput [formControl]="duration" [isCurrencyMask]="true" data-panel="eventSettings" label='Duration in minutes'>
                        <input  #inputNameC currencyMask [formControl]="duration"  [options]="{ allowNegative: false, prefix: '', inputMode: 1 }" class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                    <mdb-error class="form-fill-error"  *ngIf="duration.invalid && duration.touched ">Please provide Event Duration</mdb-error>
                    <mdb-error class="form-fill-error"  *ngIf="duration.hasError('min') && duration.touched ">Duration should not be less than 1 mins</mdb-error>
                    <mdb-error class="form-fill-error"  *ngIf="duration.hasError('max') && duration.touched ">Duration should be less than 1440 mins</mdb-error>
                </mdb-form-control>
            </div>
            <div class="col-6" [formGroup]="timeZoneData">
                <mdb-form-control class="form-fill">
                    <mdb-select formControlName="name" class="mdb-select" [filter]="true">
                      <mdb-option *ngFor="let timeZone of timeZoneList" [value]="timeZone.value">{{
                        timeZone.label
                      }}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label form-label--paybee">Time Zone</label>
                  </mdb-form-control>
            </div>
        </div>
    </div>
    <div class="modal-footer paybee-modal-footer">
      <div class="row">
        <div class="col-4 offset-4">
          <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" (click)="close(dialog, false)">{{ dialog.initialState.buttonCancel || "Cancel" }}</button>
        </div>
        <div class="col-4">
          <button type="button" class="btn btn--paybee modal-confirm-button btn--md text-center w-100" (click)="onCopyClick(dialog)">Copy</button>
        </div>
      </div>
    </div>  
  </ng-container>